import React, { useEffect, useState } from 'react'
import { Col, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import SpinerVeye from '../../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../../conexoes/api'
import {
    mudarDoppleGangerCliente,
    revelarDoppelgangerCliente,
    visualizarDadosRefresh
} from '../../../../redux/actions/index'
import { elipseVerde } from '../../../../utils/alternanciaIcones'
import decryptJWT from '../../../../utils/decryptJWT'
import MensagemErro from '../../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../../componentesModais/mensagens/mensagemSucesso'
import TabelaGenerica from '../../../componentesModais/tabela/tabela'
// import AlterarLogin from '../../alterarLogin/alterarLogin'

let offset = 0
let uniqueKeys = []

export default function InformacoesLogin(props) {
  //   const [renderizar, setRenderizar] = useState(false)
  //   const [nome, setNome] = useState()
  //   const [sobrenome, setSobrenome] = useState()
  //   const [cpf, setCpf] = useState()
  //   const [cnpj, setCnpj] = useState()
  //   const [email, setEmail] = useState()
  //   const [telefone, setTelefone] = useState()
  //   const [cdPerfil, setCdPerfil] = useState()
  //   const [dsPerfil, setDsPerfil] = useState()
  //   const [cdUsuario, setCdUsuario] = useState()
  const [spinAtivo, setSpinAtivo] = useState(false)
  const [cdCliente, setCdCliente] = useState()
  const [dsCliente, setDsCliente] = useState('NULL')
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const despacho = useDispatch()
  const limitePagina = 7
  const [initialLoad, setInitialLoad] = useState(false)
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [ordenador, setOrdenador] = useState('')
  const [itens, setItens] = useState([])
  const [numeroItens, setNumeroItens] = useState(-1)
  const [emptyResponseMessage, setEmptyResponseMessage] = useState('')
  const mensagemErro = 'Ocorreu um erro. Por favor tente novamente mais tarde.'

  //   let reduxRevelarAlterarAdicionarLogin = useSelector(
  //     (state) => state.virtueyesState.revelarAlterarAdicionarLogin
  //   )
  let revelarDoppelgangerClienteVar = useSelector(
    (state) => state.virtueyesState.revelarDoppelgangerCliente
  )
  let visualizarDadosRefreshVar = useSelector(
    (state) => state.virtueyesState.visualizarDadosRefresh
  )

  useEffect(() => {
    setSpinAtivo(true)
    async function handleCarregarInformacoesLogin() {
      //CARREGAMENTO INICIAL DO COMPONENTE
      offset = (paginaAtual - 1) * limitePagina
      if (initialLoad === false) {
        let resposta = await api_gateway.post(
          '/m1/consultar/painel_virtueyes_detalhamento_cliente_clientes_do_cliente_tabela',
          {
            codigo_cliente: props.cdCliente,
            limit: limitePagina,
            offset: offset,
            ordenador: ordenador,
            dataSet: uniqueKeys
          }
        )
        //CRIAÇÃO DE DATASET PARA ACESSO RÁPIDO UTILIZANDO UNIQUE KEYS
        resposta.data.dados.map((item) => {
          uniqueKeys.push(item.CD_PAV_CLIENTE)
        })
        if (uniqueKeys.length === 0) {
          setEmptyResponseMessage('Este cliente nao possui clientes')
        }
        setNumeroItens(uniqueKeys.length)
        setInitialLoad(true)
      }
      //ROTINA DE PAGINAÇÃO
      let resposta = await api_gateway.post(
        '/m1/consultar/painel_virtueyes_detalhamento_cliente_clientes_do_cliente_tabela',
        {
          codigo_cliente: props.cdCliente,
          limit: limitePagina,
          offset: offset,
          ordenador: ordenador,
          dataSet: uniqueKeys
        }
      )
      setItens(resposta.data.dados)
      setSpinAtivo(false)
    }
    handleCarregarInformacoesLogin()
  }, [props.cdCliente, paginaAtual])

  useEffect(() => {
    if (cdCliente > 0 && revelarDoppelgangerClienteVar === true) {
      handleDoppelgangerCliente()
    }
  }, [revelarDoppelgangerClienteVar])

  async function handleDoppelgangerCliente(
    cdCliente,
    noCdCliente,
    ds_nome,
    n0_nivel
  ) {
    setCdCliente(cdCliente)
    setDsCliente(ds_nome)
    if (cdCliente !== undefined && noCdCliente !== undefined) {
      setSpinAtivo(true)
      let fatContas = []
      const contasUsuario = await api_gateway.get(
        'm1/consultar/fat_conta/contas_usuario?cd_pav_usuario=' +
          decryptJWT('codigo')
      )
      await Promise.all(
        contasUsuario.data.dados.map((item) => {
          fatContas.push(item.cd_fat_conta)
        })
      )
      if (contasUsuario.data.dados.length == 0) {
        fatContas = [0]
      }
      const request =
        '/m1/servicos/alterar_token?login=' +
        decryptJWT('login') +
        '&email=' +
        decryptJWT('email') +
        '&codigo=' +
        decryptJWT('codigo') +
        '&codigoCliente=' +
        cdCliente +
        '&codigoClienteErpAntigo=' +
        noCdCliente +
        '&codigoClienteTexto=' +
        noCdCliente +
        '&nomeDeUsuario=' +
        decryptJWT('nomeDeUsuario') +
        '&perfil=' +
        decryptJWT('perfil') +
        '&cdSmsContaUsuario=' +
        decryptJWT('cdSmsContaUsuario') +
        '&id=' +
        decryptJWT('id') +
        '&fatContas=' +
        fatContas +
        '&clienteNivel=' +
        n0_nivel +
        '&tipoPerfil=' +
        decryptJWT('tipoPerfil') +
        '&clientePrimario=' +
        decryptJWT('clientePrimario')

      await api_gateway
        .get(request)
        .then(function (response) {
          localStorage.setItem('@veye-Token', response.data.dados.token)
        })
        .catch(function () {})
      setRevelarMensagemSucesso(true)
    }
    setSpinAtivo(false)
    despacho(mudarDoppleGangerCliente(false))
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
      
    }
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      despacho(revelarDoppelgangerCliente(false))
      despacho(visualizarDadosRefresh(!visualizarDadosRefreshVar))
      
    }
  }

  return (
    <div className="container-informacoes-login">
      {/* {reduxRevelarAlterarAdicionarLogin === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <AlterarLogin
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              codigo_cliente={props.noCdCliente}
              nome={nome}
              sobrenome={sobrenome}
              email={email}
              telefone={telefone}
              cdPerfil={cdPerfil}
              dsPerfil={dsPerfil}
              cdUsuario={cdUsuario}
              cpf={cpf}
              cnpj={cnpj}
            />
          </div>
        </div>
      )} */}
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <div className="container-informacoes-login-telas">
        <div className="container-informacoes-login-resumo fundo-cor-7">
          <Form.Row>
            <Col>
              <img
                className="icone-label-janela nao-selecionavel"
                src={elipseVerde()}
                alt="elipse"
              />
              <Form.Label>
                <div className="fonte-cor-1 label-janela">Clientes</div>
              </Form.Label>
            </Col>
          </Form.Row>
          {itens != '' && itens != undefined && itens != null && (
            <TabelaGenerica
              tabela="componente_virtueyes_detalhamento_cliente-clientes"
              ordenador={ordenador}
              setOrdenador={setOrdenador}
              limitePagina={limitePagina}
              paginaAtual={paginaAtual}
              setPaginaAtual={setPaginaAtual}
              itens={itens}
              totalItens={numeroItens}
            />
          )}
          {initialLoad === true && emptyResponseMessage != '' && (
            <div className="fonte-cor-1">{emptyResponseMessage}</div>
          )}
        </div>
      </div>
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1={'O cliente ' + dsCliente + ','}
              mensagemParagrafo2={'cód. ' + cdCliente + ' foi carregado.'}
              mensagemBotao="OK"
            />
          </div>
        </div>
      )}
    </div>
  )
}
